/* eslint-disable max-lines */
import { clearURLParams, fetchCustomerRecipientsDomain, setURLParams } from 'actions';
import DropdownFilter from 'components/Filters/DropdownFilter/DropdownFilter';
import SearchInput from 'components/SearchInput';
import SelectRedesign from 'components/Select/SelectRedesign';
import { resourceQueryParamName } from 'constants/resourceQueryNames';
import { useNavParamsByResource } from 'hooks/nav/useNavParamsByResource';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCustomerRecipientsDomain, getCustomerRecipientsDomainLoading } from 'selectors/users';

const onRiskOptions = [
  {
    value: 'ascending',
    label: 'Ascending',
  },
  {
    value: 'descending',
    label: 'Descending',
  },
];

const AdditionalUsersFilters: React.FC = () => {
  const dispatch = useDispatch();

  const params = useNavParamsByResource(resourceQueryParamName.user);

  let orderBy = '';
  if (params.order_by === 'on_risk') {
    if (params.order_desc === 'true') {
      orderBy = 'descending';
    } else {
      orderBy = 'ascending';
    }
  }

  const [onRisk, setOnRisk] = useState(orderBy);

  const handleOnRiskSelect = (value: string): void => {
    if (value === 'ascending') {
      dispatch(
        setURLParams({
          [`${resourceQueryParamName.user}__order_by`]: 'on_risk',
          [`${resourceQueryParamName.user}__order_desc`]: 'false',
          [`${resourceQueryParamName.user}__offset`]: '0',
        })
      );
    } else {
      dispatch(
        setURLParams({
          [`${resourceQueryParamName.user}__order_by`]: 'on_risk',
          [`${resourceQueryParamName.user}__order_desc`]: 'true',
          [`${resourceQueryParamName.user}__offset`]: '0',
        })
      );
    }

    setOnRisk(value);
  };

  const handleClearFilters = (): void => {
    dispatch(clearURLParams());
  };

  return (
    <div className="flex flex-row gap-2 flex-wrap">
      <SearchInput
        resource={resourceQueryParamName.user}
        field="broad_search"
        className="h-8 max-w-68"
        placeholder="Search users by name or email"
      />

      <div className="w-35">
        <DropdownFilter
          resource={resourceQueryParamName.user}
          fetchAction={fetchCustomerRecipientsDomain}
          filterKey="domains"
          itemField="uuid"
          getResourceList={getCustomerRecipientsDomain}
          getLoading={getCustomerRecipientsDomainLoading}
          title="Domain"
          nameKey="name"
          notFoundText="No domains found"
          searchKey="broad_search"
        />
      </div>

      <div className="w-35">
        <SelectRedesign
          placeholder="Risk"
          onChange={handleOnRiskSelect}
          options={onRiskOptions}
          value={onRisk}
        />
      </div>

      <button
        type="button"
        className="text-body self-end focus:outline-none"
        onClick={handleClearFilters}
      >
        <span className="text-litlingo-primary underline">Clear All</span>
      </button>
    </div>
  );
};

export default AdditionalUsersFilters;
